const privatePath = 'https://app.studioninja.co/build/release-pipeline-10/resources/dist/pages/private/';
const publicPath = 'https://app.studioninja.co/build/release-pipeline-10/resources/dist/pages/public/';
const clientPath = 'https://app.studioninja.co/build/release-pipeline-10/resources/dist/pages/client/';
const adminPath = 'https://app.studioninja.co/build/release-pipeline-10/resources/dist/pages/admin/';
const modernPath = 'https://app.studioninja.co/build/release-pipeline-10/resources/dist/components/';

export const routes = {
	'/': {
		templateUrl: publicPath + 'home.html',
		requireLogin: true,
		adminPage: false,
		title: ' - Dashboard',
		controller: 'BasePathController'
	},
	'/unsupported_browser': {
		templateUrl: publicPath + 'non_supported_browser.html',
		requireLogin: false,
		adminPage: false,
		hideHeader: true,
		title: ' - Unsupported browser'
	},
	'/login': {
		templateUrl: publicPath + 'login.html',
		controller: 'LoginController',
		requireLogin: false,
		adminPage: false,
		hideHeader: true,
		title: ' - Login'
	},
	'/signup': {
		templateUrl: publicPath + 'sign_up.html',
		controller: 'SignUpController',
		requireLogin: false,
		adminPage: false,
		hideHeader: true,
		title: ' - Sign up'
	},
	'/signup/referral/:token': {
		templateUrl: publicPath + 'sign_up.html',
		controller: 'SignUpController',
		requireLogin: false,
		adminPage: false,
		hideHeader: true,
		title: ' - Sign up'
	},
	'/signup/confirm/:token': {
		templateUrl: publicPath + 'simple_result.html',
		controller: 'ConfirmSignUpController',
		requireLogin: false,
		hideHeader: true,
		adminPage: false
	},
	'/signup/thankyou': {
		templateUrl: publicPath + 'thank_you_signup.html',
		controller: 'ThankYouSignupController',
		requireLogin: false,
		hideHeader: true,
		adminPage: false
	},
	'/pageNotFound': {
		templateUrl: publicPath + 'sorry_page.html',
		requireLogin: false,
		hideHeader: true,
		adminPage: false
	},
	'/unsubscribefromintroemails/:token': {
		templateUrl: publicPath + 'simple_result.html',
		controller: 'UnsubscribeEmailsController',
		requireLogin: false,
		adminPage: false,
		title: ' - Unsubscribe'
	},
	'/forgot': {
		templateUrl: publicPath + 'forgot_password.html',
		controller: 'ForgotPasswordController',
		requireLogin: false,
		adminPage: false,
		title: ' - Password recovery'
	},
	'/tlc': {
		templateUrl: publicPath + 'tlc.html',
		controller: 'ForgotPasswordController',
		requireLogin: false,
		adminPage: false,
		hideHeader: true,
		title: ' - Maintenance'
	},
	'/new/confirm/:token': {
		templateUrl: publicPath + 'public_change_password.html',
		controller: 'ConfirmForgotPasswordController',
		requireLogin: false,
		adminPage: false
	},
	'/settings': {
		templateUrl: privatePath + 'settings.html',
		controller: 'SettingsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Settings'
	},
	'/settings/company/:companyId/edit': {
		templateUrl: privatePath + 'company_information.html',
		controller: 'CompanyInformationController',
		requireLogin: true,
		adminPage: false,
		title: ' - Edit Company'
	},
    '/settings/companies': {
        templateUrl: privatePath + 'settings_companies.html',
        controller: 'CompanyUsersController',
        requireLogin: true,
        adminPage: false,
        title: ' - Companies'
    },
	'/company/register/:token': {
		templateUrl: publicPath + 'sign_up.html',
		controller: 'SignUpController',
		requireLogin: false,
		adminPage: false
	},
	'/settings/users': {
		templateUrl: privatePath + 'company_users.html',
		controller: 'CompanyUsersController',
		requireLogin: true,
		adminPage: false,
		title: ' - Company Users'
	},
	'/settings/profile': {
		templateUrl: privatePath + 'profile.html',
		controller: 'ProfileController',
		requireLogin: true,
		adminPage: false,
		title: ' - Account & Subscription'
	},
    '/subscribed': {
        templateUrl: privatePath + 'thank-for-subscribing.html',
        requireLogin: true,
        adminPage: false
    },
	// TODO remove after implementing Stripe v3
	// '/pay/stripe': {
	// 	templateUrl: privatePath + 'stripe_pay.html',
	// 	controller: 'StripeActionsController',
	// 	requireLogin: true,
	// 	adminPage: false
	// },
	'/change/confirm/:token': {
		templateUrl: publicPath + 'simple_result.html',
		controller: 'ChangePasswordController',
		requireLogin: true,
		adminPage: false
	},
	'/change/login/confirm/:token': {
		templateUrl: publicPath + 'simple_result.html',
		controller: 'ChangeLoginController',
		requireLogin: false,
		adminPage: false
	},
	// TODO remove after implementing Stripe v3
	// '/subscription': {
	// 	templateUrl: privatePath + 'subscription_plan.html',
	// 	controller: 'SubscriptionController',
	// 	requireLogin: true,
	// 	adminPage: false,
	// 	hideHeader: true,
	// 	role: 'user',
	// 	title: ' - Subscription'
	// },
	'/ambassadors': {
		templateUrl: adminPath + 'ambassadors.html',
		controller: 'AmbassadorsController',
		requireLogin: true,
		adminPage: true,
		title: ' - Ambassadors'
	},
	'/referrals': {
		templateUrl: adminPath + 'referrals.html',
		controller: 'ReferralsController',
		requireLogin: true,
		adminPage: true,
		title: ' - Referrals'
	},
	'/campaigns': {
		templateUrl: adminPath + 'campaigns.html',
		controller: 'CampaignsController',
		requireLogin: true,
		adminPage: true,
		title: ' - Campaigns'
	},
	'/settings/currency_and_taxes': {
		templateUrl: privatePath + 'currency_and_taxes.html',
		controller: 'CurrencyAndTaxesController',
		requireLogin: true,
		adminPage: false,
		title: ' - Currency & Taxes'
	},
	'/settings/payment_schedules': {
		templateUrl: privatePath + 'payment_schedules.html',
		controller: 'PaymentSchedulesController',
		requireLogin: true,
		adminPage: false,
		title: ' - Payment Schedules & Reminders'
	},

	'/settings/products_packages': {
		templateUrl: privatePath + 'products.html',
		controller: 'ProductsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Products & Packages'
	},
	'/jobs': {
		templateUrl: privatePath + 'jobs.html',
		controller: 'JobsOverviewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Jobs Overview'
	},
	'/settings/payment_methods': {
		templateUrl: privatePath + 'payment_methods.html',
		controller: 'PaymentMethodsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Payment Methods'
	},
	'/jobs/view/:jobId': {
		templateUrl: privatePath + 'job_view.html',
		controller: 'JobViewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Job Profile',
		role: 'user'
	},
	'/jobs/:jobId/invoice/:invoiceId/update': {
		templateUrl: privatePath + 'update_invoice.html',
		controller: 'UpdateInvoiceController',
		requireLogin: true,
		adminPage: false,
		title: ' - Update Invoice'
	},
	'/jobs/:jobId/invoice/new': {
		templateUrl: privatePath + 'update_invoice.html',
		controller: 'UpdateInvoiceController',
		requireLogin: true,
		adminPage: false,
		title: ' - New Invoice'
	},
	'/leads/:leadId/invoice/new': {
		templateUrl: privatePath + 'update_invoice.html',
		controller: 'UpdateInvoiceController',
		requireLogin: true,
		adminPage: false,
		title: ' - New Invoice'
	},
	'/leads/:leadId/invoice/:invoiceId/update': {
		templateUrl: privatePath + 'update_invoice.html',
		controller: 'UpdateInvoiceController',
		requireLogin: true,
		adminPage: false,
		title: ' - Update Invoice'
	},
	'/leads/:leadId': {
		templateUrl: privatePath + 'leads.html',
		controller: 'leadsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Leads Overview',
		role: 'user'
	},
	'/leads/view/:leadId': {
		templateUrl: privatePath + 'lead_view.html',
		controller: 'LeadViewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Lead Profile',
		role: 'user'
	},
	'/payments': {
		templateUrl: privatePath + 'payments_overview.html',
		controller: 'PaymentsOverviewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Payments Overview'
	},
	'/payments/payment/:id': {
		templateUrl: privatePath + 'invoice_view.html',
		controller: 'InvoiceViewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Invoice'
	},
	'/invoices/:id': {
		templateUrl: privatePath + 'invoice_view.html',
		controller: 'InvoiceViewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Invoice'
	},
	'/settings/email_settings': {
		templateUrl: privatePath + 'email_settings.html',
		controller: 'EmailSettingsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Email Settings'
	},
	'/settings/email_templates': {
		templateUrl: privatePath + 'email_templates.html',
		controller: 'EmailTemplatesController',
		requireLogin: true,
		adminPage: false,
		title: ' - Email Templates'
	},
	'/settings/email_template': {
		redirectTo: '/settings/email_settings'
	},
	'/clients': {
		templateUrl: privatePath + 'clients.html',
		controller: 'ClientsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Clients Overview'
	},
	'/settings/questionnaires': {
		templateUrl: privatePath + 'questionnaires.html',
		controller: 'QuestionnairyController',
		requireLogin: true,
		adminPage: false,
		title: ' - Questionnaire Templates'
	},
	'/settings/contracts': {
		templateUrl: privatePath + 'contracts.html',
		controller: 'ContractsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Contract Templates'
	},
	'/settings/workflows': {
		templateUrl: privatePath + 'workflows.html',
		controller: 'WorkflowController',
		requireLogin: true,
		adminPage: false,
		title: ' - Workflows'
	},
	'/settings/workflows/add': {
		templateUrl: privatePath + 'add_new_workflow.html',
		controller: 'AddWorkflowController',
		requireLogin: true,
		adminPage: false
	},
	'/settings/workflows/edit/:id': {
		templateUrl: privatePath + 'add_new_workflow.html',
		controller: 'AddWorkflowController',
		requireLogin: true,
		adminPage: false,
		title: ' - Add a new workflow'
	},
	'/settings/workflows/duplicate/:id': {
		templateUrl: privatePath + 'add_new_workflow.html',
		controller: 'AddWorkflowController',
		requireLogin: true,
		adminPage: false,
		title: ' - Edit workflow'
	},
	'/clients/client:id': {
		templateUrl: privatePath + 'client_profile.html',
		controller: 'ClientProfileController',
		requireLogin: true,
		adminPage: false,
		title: ' - Client Profile'
	},

	'/jobs/view/:jobId/contracts': {
		templateUrl: privatePath + 'job_contracts.html',
		controller: 'JobContractController',
		requireLogin: true,
		adminPage: false,
		title: ' - Contract'
	},
	'/leads/view/:leadId/contracts': {
		templateUrl: privatePath + 'job_contracts.html',
		controller: 'JobContractController',
		requireLogin: true,
		adminPage: false,
		title: ' - Contract'
	},
	'/jobs/view/:jobId/questionnaires/:questionnaireId': {
		templateUrl: privatePath + 'job_questionnaires.html',
		controller: 'JobQuestionnaireController',
		requireLogin: true,
		adminPage: false,
		title: ' - Questionnaire'
	},
	'/leads/view/:leadId/questionnaires/:questionnaireId': {
		templateUrl: privatePath + 'job_questionnaires.html',
		controller: 'JobQuestionnaireController',
		requireLogin: true,
		adminPage: false,
		title: ' - Questionnaire'
	},
	'/jobs/view/:jobId/contracts/:contractId': {
		templateUrl: privatePath + 'job_contracts.html',
		controller: 'JobContractController',
		requireLogin: true,
		adminPage: false,
		title: ' - Contract'
	},
	'/leads/view/:leadId/contracts/:contractId': {
		templateUrl: privatePath + 'job_contracts.html',
		controller: 'JobContractController',
		requireLogin: true,
		adminPage: false,
		title: ' - Contract'
	},
	'/jobs/:jobId/quote/:quoteId/update': {
		templateUrl: privatePath + 'update_quote.html',
		controller: 'UpdateQuoteController',
		requireLogin: true,
		adminPage: false,
		title: ' - Update Quote'
	},
	'/leads/:leadId/quote/:quoteId/update': {
		templateUrl: privatePath + 'update_quote.html',
		controller: 'UpdateQuoteController',
		requireLogin: true,
		adminPage: false,
		title: ' - Update Quote'
	},
	'/jobs/:jobId/quote/:quoteType/new': {
		templateUrl: privatePath + 'update_quote.html',
		controller: 'UpdateQuoteController',
		requireLogin: true,
		adminPage: false,
		title: ' - New Quote'
	},
	'/leads/:leadId/quote/:quoteType/new': {
		templateUrl: privatePath + 'update_quote.html',
		controller: 'UpdateQuoteController',
		requireLogin: true,
		adminPage: false,
		title: ' - New Quote'
	},
	'/jobs/:jobId/quote/:quoteId': {
		templateUrl: privatePath + 'quote_view.html',
		controller: 'QuoteViewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Quote'
	},
	'/leads/:leadId/quote/:quoteId': {
		templateUrl: privatePath + 'quote_view.html',
		controller: 'QuoteViewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Quote'
	},
	'/settings/google_cal': {
		templateUrl: privatePath + 'calendar_settings.html',
		controller: 'CalendarSettingsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Calendar Settings'
	},
	'/settings/job_types': {
		templateUrl: privatePath + 'job_types.html',
		controller: 'JobTypesController',
		requireLogin: true,
		adminPage: false,
		title: ' - Job Types'
	},
	'/settings/contact_form': {
		templateUrl: privatePath + 'contact_form.html',
		controller: 'ContactFormController',
		requireLogin: true,
		adminPage: false,
		title: ' - Contact Form'
	},
	'/settings/refer': {
		templateUrl: privatePath + 'refer.html',
		controller: 'ReferController',
		requireLogin: true,
		adminPage: false,
		title: ' - Refer a Friend'
	},
	'/settings/integrations/:xero?': {
		templateUrl: privatePath + 'integrations.html',
		controller: 'IntegrationsController',
		requireLogin: true,
		adminPage: false,
		title: ' - Integrations'
	},
	'/calendar': {
		templateUrl: privatePath + 'calendar.html',
		controller: 'CalendarController',
		requireLogin: true,
		adminPage: false,
		title: ' - Calendar'
	},
	'/leads': {
		templateUrl: privatePath + 'leads.html',
		controller: 'LeadsOverviewController',
		requireLogin: true,
		adminPage: false,
		title: ' - Leads Overview'
	},
	'/:photographyStudio/contact': {
		templateUrl: clientPath + 'client_contact_form.html',
		controller: 'ClientContactFormController',
		requireLogin: false,
		adminPage: false,
		title: 'Contact Form',
		role: 'company'
	},
	'/:photographyStudio/contact/:id': {
		templateUrl: clientPath + 'client_contact_form.html',
		controller: 'ClientContactFormController',
		requireLogin: false,
		adminPage: false,
		title: 'Contact Form',
		role: 'company'
	},
	// TODO remove after implementing Stripe v3
	// '/reactivate': {
	// 	templateUrl: privatePath + 'reactivate_card.html',
	// 	controller: 'ReactivateCardController',
	// 	requireLogin: true,
	// 	adminPage: false,
	// 	hideHeader: true,
	// 	role: 'user',
	// 	title: ' - Reactivate Card'
	// }
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=ls9lvp2s4pi!./web/js/helper/routes.ts